import { useEffect, useMemo } from "react";
import { Crown } from "lucide-react";

const COLORS = ["#FBBF24", "#F59E0B", "#EC4899", "#DB2777", "#10B981", "#34D399"];

export const Celebration = ({ show, onDone, duration = 2200 }) => {
  const pieces = useMemo(
    () =>
      Array.from({ length: 42 }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        delay: Math.random() * 0.35,
        dur: 1.6 + Math.random() * 1.1,
        size: 6 + Math.random() * 8,
        color: COLORS[i % COLORS.length],
        rounded: Math.random() > 0.5,
      })),
    // regenerate each time it shows
    [show] // eslint-disable-line react-hooks/exhaustive-deps
  );

  useEffect(() => {
    if (!show) return;
    const t = setTimeout(() => onDone?.(), duration);
    return () => clearTimeout(t);
  }, [show, duration, onDone]);

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[60] pointer-events-none overflow-hidden" data-testid="premium-celebration">
      {pieces.map((p) => (
        <span
          key={p.id}
          style={{
            left: `${p.left}%`,
            top: "-6vh",
            width: `${p.size}px`,
            height: `${p.size}px`,
            background: p.color,
            borderRadius: p.rounded ? "999px" : "2px",
            animation: `doek-confetti ${p.dur}s cubic-bezier(.3,.6,.4,1) ${p.delay}s forwards`,
          }}
          className="absolute"
        />
      ))}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="relative" style={{ animation: "doek-crown-pop .7s cubic-bezier(.2,.8,.2,1) both" }}>
          <div className="absolute inset-0 rounded-full bg-amber-400/30 blur-2xl scale-150" />
          <div className="relative h-24 w-24 rounded-full bg-amber-500/20 border border-amber-400/50 flex items-center justify-center shadow-[0_0_40px_rgba(245,158,11,0.6)]">
            <Crown className="h-12 w-12 text-amber-300" />
          </div>
        </div>
      </div>
    </div>
  );
};
